export * from './charts';
export * from './mocks';
export * from './api';

export const SHARED_TRANSLATION = 'common';
export const SORTING = {
  ASC: 'asc',
  DESC: 'desc',
};

export const USER_FORM_MAX_LENGTH = {
  EMAIL: 100,
  FIRST_NAME: 50,
  LAST_NAME: 50,
  MIN_PHONE_NUMBER: 10,
  MAX_PHONE_NUMBER: 11,
  DATE: 10,
};
